export const BROWSER_BASENAMES = {
    BRAVE: 'brave.com',
    CHROME: 'chrome.com',
    CHROME_ALT: 'fas-chrome.com',
    DISSENTER: 'dissenter.exe',
    EDGE: 'microsoftedge.exe',
    EDGE_CHROMIUM: 'microsoftedgewelcome.microsoft.com',
    FIREFOX: 'firefox.com',
    OPERA: 'www.opera.com',
    SAFARI: 'safari'
};
